import React from 'react';

interface Props {
  children: React.ReactNode;
  label: string;
  icon: string;
  status?: React.ReactNode;
  subtitle?: React.ReactNode;
}

export default function NylasGrant({ children, label, icon, status, subtitle }: Props) {
  return (
    <div className="d-flex align-items-center gap-3 p-3 border-bottom">
      <img src={icon} style={{ width: 24, height: 24 }} />

      <div className="flex-fill">
        <div>{label}{status && <>: {status}</>}</div>
        <div className="fs-xs text-muted">{subtitle}</div>
      </div>

      {children}
    </div>
  );
}
